import { Immutable } from "immer";
import React from "react";
import { useStaticURL } from "tsi-common-react/src/utils/urls";

import type { StoreLocator as Value } from "@reactivated";

type IProps = Immutable<{
    value: Value | null;
}>;

/**
 * Faithful JSX transcription of the legacy sealy
 * ``components/store_locator/store_locator.html`` (#33285). The block is a
 * value-less StaticBlock: the serialized value is an empty object (or null on
 * the standalone template path) and is ignored.
 */
export const StoreLocator = (_props: IProps): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <section
            className="panel panel--center featured-retailer"
            style={{
                backgroundImage: `url('${staticURL}img/store-locator/panel-bg-featured-locations.jpg')`,
            }}
        >
            <div className="panel__content">
                <div className="lead-in">
                    <h2>Feel the Sealy difference for yourself</h2>
                    <a
                        className="button"
                        href="/find-a-retailer"
                        title="Find a Retailer"
                    >
                        Visit a retailer near you
                    </a>
                </div>
                <div className="value-props">
                    <div className="value-props__item">
                        <figure className="value-props__icon">
                            <img
                                className="img-responsive"
                                src={`${staticURL}img/store-locator/icon-shopping-tips.png`}
                                alt="Shopping Tips"
                                loading="lazy"
                                decoding="async"
                            />
                        </figure>
                        <a
                            className="value-props__copy"
                            href="/shopping-tips"
                            title="Shopping Tips"
                        >
                            <h4 className="value-props__headline">
                                Mattress Shopping Tips
                            </h4>
                            <p className="value-props__subtext">
                                Tips for your in-store experience
                            </p>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};
